import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'medsurf-design-content-toolbar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './toolbar.content.design.html',
    styleUrls: ['./toolbar.content.design.scss'],
    standalone: false
})
export class ToolbarContentDesign {
}
